import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/related/page-shard@2x.png")